"use client"

/*
 * CHANGE_SUMMARY
 *   [2026-08-25] CLAWE-313: route-level loading state for public pages
 */

import { Skeleton } from "@/components/ui/skeleton"

export default function Loading() {
  return (
    <div className="mx-auto w-full max-w-6xl space-y-8 p-6">
      <Skeleton variant="text" className="h-12 w-96 max-w-full" />
      <Skeleton variant="text" className="h-6 w-full" />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {Array.from({ length: 3 }, (_, i) => (
          <Skeleton key={i} variant="card" className="h-48" />
        ))}
      </div>
    </div>
  )
}
